'use strict';
(() => {
  window.ToscaCartonTotal = window.ToscaOffers.selectedTotal;
  const settings = window.ToscaShop || {};
  const adapter = new ToscaCartAdapter({root: settings.root || '/'});
  const money = cents => new Intl.NumberFormat('en-AU', {
    style: 'currency', currency: adapter.cart?.currency || settings.currency || 'AUD'
  }).format(cents / 100);
  const status = document.querySelector('#status');
  const dialog = document.querySelector('#cart-dialog');
  const cartBody = document.querySelector('#cart-body');
  const forms = [...document.querySelectorAll('.shop-buy')];
  // Spoon offer presentation only: native Shopify discounts and cart writes stay unchanged.
  for (const form of forms) {
    if (!form.classList.contains('pdp-buy') || Number(form.elements.id.value) !== 53910180626739) continue;
    const variant = JSON.parse(form.querySelector('.variant-data').textContent).find(v => v.id === 53910180626739);
    if (!variant?.available || variant.price !== 4500 || variant.maxQuantity < 5) continue;
    form.dataset.spoonOffer = 'true';
    form.dataset.unit = 'box';
    form.elements.quantity.value = '5';
    form.elements.quantity.setAttribute('aria-label', 'Number of boxes of 1,000 spoons');
    form.elements.quantity.closest('label').firstChild.textContent = 'Boxes ';
    const choices = document.createElement('div');
    choices.className = 'spoon-offer-choices';
    choices.setAttribute('role', 'group');
    choices.setAttribute('aria-label', 'Choose your spoon pack');
    for (const [quantity, label] of [[5, '5 boxes · $200 incl. GST'], [1, 'Try 1 box · $49.50 incl. GST']]) {
      const button = document.createElement('button');
      button.type = 'button'; button.textContent = label;
      button.dataset.spoonQuantity = String(quantity);
      button.addEventListener('click', () => {
        form.elements.quantity.value = String(quantity);
        form.elements.quantity.dispatchEvent(new Event('input', {bubbles:true}));
        form.elements.quantity.dispatchEvent(new Event('change', {bubbles:true}));
      });
      choices.append(button);
    }
    form.querySelector('.qty-row').before(choices);
    const note = document.createElement('p');
    note.className = 'spoon-offer-note';
    note.textContent = 'Delivery extra · Free Mortdale pickup. Discount applied automatically in your cart.';
    form.querySelector('.qty-row').after(note);
  }
  const cartPageForm = document.querySelector('.cart-page-form');
  const variants = new WeakMap();
  let trigger;
  let operationPending = false;
  let drawVersion = 0;
  let catalogueCache;
  const addonSeen = new Set();
  const feedback = document.querySelector('#cart-feedback');
  const say = message => {
    if (dialog?.open && feedback) {
      feedback.textContent = message;
      if (status) status.textContent = '';
    } else {
      const pageFeedback = document.querySelector('.cart-page-feedback');
      if (pageFeedback) pageFeedback.textContent = message;
      else if (status) status.textContent = message;
    }
  };
  const addonGroups = [
    ['2-cup-trays', '4-cup-trays'],
    ['plant-starch-spoons'],
    ['6mm-sugar-cane-straws', '8mm-sugar-cane-straws']
  ];
  const addonPacks = {
    '2-cup-trays': '600 trays / carton',
    '4-cup-trays': '400 trays / carton',
    'plant-starch-spoons': '1,000 spoons / carton',
    '6mm-sugar-cane-straws': '600 straws / box',
    '8mm-sugar-cane-straws': '300 straws / box'
  };

  async function addonCatalogue() {
    if (catalogueCache && Date.now() - catalogueCache.at < 30000) return catalogueCache.promise;
    const promise = Promise.all(addonGroups.flat().map(async handle => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 4500);
      try {
        const response = await fetch(adapter.root + 'products/' + handle + '.js', {
          credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
          headers: {'Accept': 'application/json'}
        });
        if (!response.ok) return null;
        const product = await response.json();
        const variant = product.variants?.find(item => item.available && Number.isSafeInteger(item.id) && Number.isInteger(item.price) && item.price > 0);
        if (product.handle !== handle || product.requires_selling_plan || !variant) return null;
        return {handle, title: product.title, id: variant.id, price: variant.price, image: product.featured_image};
      } catch { return null; }
      finally { clearTimeout(timeout); }
    }));
    catalogueCache = {at: Date.now(), promise};
    return promise;
  }

  async function drawAddons(cart, version) {
    if (!cart.items.length || adapter.uncertain || cart.items.some(item => item.selling_plan_allocation || item.handle === 'custom-printed-pet-cans')) return;
    const handles = new Set(cart.items.map(item => item.handle));
    const missing = addonGroups.filter(group => !group.some(handle => handles.has(handle)));
    if (!missing.length || !addonGroups.flat().some(handle => handles.has(handle))) return;
    const catalogue = await addonCatalogue();
    if (version !== drawVersion || !dialog?.open || adapter.uncertain) return;
    const chosen = missing.map(group => group.map(handle => catalogue.find(product => product?.handle === handle)).find(Boolean)).filter(Boolean).slice(0, 2);
    if (!chosen.length) return;
    const section = el('section', undefined, 'drawer-addons');
    section.setAttribute('aria-labelledby', 'drawer-addons-title');
    const title = el('h3', 'Complete your café order');
    title.id = 'drawer-addons-title';
    section.append(title, el('p', 'Need anything else? Add one pack below.', 'addon-intro'));
    for (const product of chosen) {
      const row = el('div', undefined, 'addon-card');
      if (product.image) {
        const photo = el('img');
        photo.src = product.image;
        photo.alt = '';
        photo.width = 52;
        photo.height = 58;
        row.append(photo);
      }
      const info = el('div', undefined, 'addon-info');
      const link = el('a', product.title);
      link.href = adapter.root + 'products/' + product.handle;
      const pack = el('span', addonPacks[product.handle], 'addon-pack');
      const price = el('strong', money(product.price) + (cart.taxes_included ? ' incl GST' : ' ex GST'), 'addon-price');
      info.append(link, pack, price);
      const add = el('button', 'Add', 'addon-add');
      add.type = 'button';
      add.dataset.addonHandle = product.handle;
      add.setAttribute('aria-label', 'Add one ' + (product.handle.includes('straws') ? 'box of ' : 'carton of ') + product.title);
      add.addEventListener('click', () => run(add, () => adapter.add([{id: product.id, quantity: 1}], {optional: true,context:'dialog',target:add}), product));
      row.append(info, add);
      section.append(row);
    }
    cartBody.append(section);
    for (const product of chosen) if (!addonSeen.has(product.handle)) {
      addonSeen.add(product.handle);
      window.ToscaRefinements?.publish('tosca_addon_shown', {product_handle:product.handle,price_cents:product.price,currency:cart.currency});
    }
    syncControls();
  }

  function el(tag, text, className) {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  }

  const includesTax = cart => cart.taxes_included ?? settings.taxesIncluded ?? false;
  function offerBar(id, quantity, inCart = false) {
    const progress = window.ToscaOffers.progress(id, quantity);
    if (!progress) return null;
    const node = el('section', undefined, 'offer-progress');
    node.setAttribute('aria-live', 'polite');
    const saving = money(Math.round(progress.saving * 1.1));
    node.append(el('strong', 'Save ' + saving + ' per ' + progress.size + ' boxes'));
    const bar = el('progress'); bar.max = progress.size; bar.value = progress.value;
    bar.setAttribute('aria-label', progress.name + ': ' + progress.value + ' of ' + progress.size + ' boxes');
    node.append(bar);
    const unlocked = progress.groups ? (inCart ? 'You’re saving ' : 'You’ll save ') + money(Math.round(progress.groups * progress.saving * 1.1)) + '. ' : '';
    const detail = progress.remaining ? 'Add ' + progress.remaining + ' more ' + (progress.remaining === 1 ? 'box' : 'boxes') + ' of ' + progress.name.toLowerCase() + ' to save ' + (progress.groups ? 'another ' : '') + saving + '.' : 'Savings applied automatically, including GST.';
    node.append(el('p', unlocked + detail));
    if (inCart) node.append(el('small', quantity + ' boxes in your order'));
    return node;
  }
  function summary(cart) {
    const amounts = window.ToscaOffers.totals(cart, includesTax(cart));
    const node = el('div', undefined, 'totals');
    function row(label, value, prominent) {
      const line = el('div', undefined, prominent ? 'grand' : 'tax-summary-row');
      line.append(el('span', label), el('strong', money(value))); node.append(line);
    }
    if (!includesTax(cart)) {
      row('Subtotal (ex GST)', amounts.subtotal);
      row('GST (10% estimate)', amounts.tax);
    }
    row('Total incl. GST', amounts.total, true);
    node.append(el('p', 'Before delivery. Final tax and delivery confirmed at checkout.', 'cart-note'));
    return node;
  }
  const changeItem = (item, quantity, options) => item.groupVariantId
    ? adapter.changeGroup(item.groupVariantId, quantity, options)
    : adapter.change(item.key, quantity, options);

  function state(form) {
    if (!variants.has(form)) variants.set(form, JSON.parse(form.querySelector('.variant-data').textContent));
    const id = Number(form.elements.id.value);
    const variant = variants.get(form).find(item => item.id === id);
    const quantity = Number(form.elements.quantity.value);
    if (!variant?.available || !(variant.price > 0) || form.dataset.planRequired === 'true') throw new Error('This product option is unavailable.');
    const maxQuantity = Number.isInteger(variant.maxQuantity) ? Math.min(30, variant.maxQuantity) : 30;
    form.elements.quantity.max = Math.max(1, maxQuantity);
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > maxQuantity) {
      throw new Error('Choose a whole quantity from 1 to ' + maxQuantity + '.');
    }
    return {id, quantity, price: variant.price};
  }

  function update(form) {
    const total = form.querySelector('.selected-total');
    const add = form.querySelector('[type="submit"]');
    try {
      const selected = state(form);
      const unit = form.dataset.unit || 'pack';
      const units = selected.quantity === 1 ? unit : unit === 'box' ? 'boxes' : unit + 's';
      form.querySelector('.unit-price').textContent = money(selected.price);
      form.querySelector('.piece-price').textContent = (selected.price / Number(form.dataset.pack)).toFixed(2) + '¢ each';
      if (form.dataset.cartonLanding === 'true') {
        const carton = selected.quantity === Number(form.dataset.cartonQuantity);
        const amount = window.ToscaCartonTotal(selected.id, selected.price, selected.quantity);
        form.querySelector('.unit-price').textContent = money(amount);
        form.querySelector('[data-price-unit]').textContent = (carton ? '/ carton ' : selected.quantity === 1 ? '/ box ' : 'total ') + form.dataset.taxLabel;
        form.querySelector('.pack-summary').textContent = selected.quantity + ' ' + units + ' · ' + (selected.quantity * Number(form.dataset.pack)).toLocaleString('en-AU') + ' straws' + (carton ? ' per carton' : '');
        form.querySelector('.piece-price').textContent = (amount / (selected.quantity * Number(form.dataset.pack))).toFixed(2) + '¢ each';
      }
      const selectedAmount = window.ToscaCartonTotal(selected.id, selected.price, selected.quantity);
      const inclusiveAmount = settings.taxesIncluded ? selectedAmount : selectedAmount + Math.round(selectedAmount / 10);
      total.textContent = money(inclusiveAmount) + ' incl. GST for ' + selected.quantity + ' ' + units + ' (' + money(selectedAmount) + ' ' + form.dataset.taxLabel + ').';
      form.querySelector('.offer-progress')?.remove();
      const progress = offerBar(selected.id, selected.quantity);
      if (progress) total.after(progress);
      if (form.dataset.spoonOffer === 'true') {
        form.querySelector('.unit-price').textContent = money(inclusiveAmount);
        form.querySelector('[data-price-unit]').textContent = 'total incl. GST';
        form.querySelector('.pack-summary').textContent = selected.quantity.toLocaleString('en-AU') + (selected.quantity === 1 ? ' box' : ' boxes') + ' · ' + (selected.quantity * 1000).toLocaleString('en-AU') + ' spoons';
        form.querySelector('.piece-price').textContent = (inclusiveAmount / (selected.quantity * 1000)).toFixed(2) + '¢ per spoon';
        form.querySelector('.pack-price').lastChild.textContent = ' incl. GST';
        form.querySelectorAll('[data-spoon-quantity]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.spoonQuantity) === selected.quantity)));
      }
      add.textContent = form.dataset.spoonOffer === 'true' && selected.quantity === 5 ? 'Get the 5-box deal' : 'Add to order';
      add.disabled = operationPending || adapter.busy || adapter.uncertain;
      return selected;
    } catch (error) {
      total.textContent = error.message;
      add.textContent = error.message.includes('unavailable') ? 'Unavailable' : 'Add to order';
      add.disabled = true;
      return null;
    }
  }

  function syncControls() {
    document.querySelectorAll('.shop-buy button,.shop-buy input:not([type="hidden"]),.shop-buy select,.shop-restock button,.shop-restock input,.shop-restock select,.cart-page-form button,.cart-page-form input,#cart-body button,#cart-body input').forEach(control => {
      control.disabled = operationPending || adapter.busy || adapter.uncertain || control.dataset.locked === 'true';
    });
    forms.forEach(update);
    if (cartBody) cartBody.setAttribute('aria-busy', String(operationPending || adapter.busy));
    if (cartPageForm) cartPageForm.setAttribute('aria-busy', String(operationPending || adapter.busy));
    const review = dialog?.querySelector('a.btn');
    if (review) review.setAttribute('aria-disabled', String(operationPending || adapter.busy));
  }

  function draw() {
    const cart = adapter.cart;
    if (!cart) return;
    const count = document.querySelector('#bag-count');
    if (count) count.textContent = cart.item_count;
    if (!cartBody) return;
    const version = ++drawVersion;
    cartBody.replaceChildren();
    const legacyItems = cart.items.some(item => item.selling_plan_allocation);
    const quoteItems = cart.items.some(item => item.handle === 'custom-printed-pet-cans');
    for (const item of window.ToscaOffers.groupedItems(cart)) {
      const line = el('div', undefined, 'cart-line');
      const photo = el('a');
      photo.href = item.url;
      photo.tabIndex = -1;
      photo.setAttribute('aria-hidden', 'true');
      if (item.image) {
        const img = el('img');
        img.src = item.image;
        img.alt = '';
        img.width = 65;
        img.height = 80;
        photo.append(img);
      }
      const info = el('div');
      const heading = el('h3');
      const link = el('a', item.product_title);
      link.href = item.url;
      heading.append(link);
      info.append(heading);
      if (item.variant_title && item.variant_title !== 'Default Title') info.append(el('p', item.variant_title));
      info.append(el('p', item.quantity + (item.groupVariantId ? ' boxes · ' : ' packs · ') + money(item.final_line_price) + (includesTax(cart) ? ' incl GST' : ' ex GST')));
      const legacy = Boolean(item.selling_plan_allocation);
      const quoteOnly = item.handle === 'custom-printed-pet-cans';
      if (quoteOnly) {
        const note = el('p', 'Custom printed cans need a quote. Remove this item before checkout. ');
        const quoteLink = el('a', 'Request a quote →');
        quoteLink.href = '/pages/can-quote';
        note.append(quoteLink);
        info.append(note);
      }
      if (legacy) info.append(el('p', 'This saved item uses an old purchase option. Remove it, then add it again from the shop before checkout.'));
      const controls = el('div', undefined, 'line-controls');
      const label = el('label', 'Quantity');
      const quantity = el('input');
      quantity.type = 'number';
      quantity.min = 1;
      quantity.max = 30;
      quantity.step = 1;
      quantity.inputMode = 'numeric';
      quantity.value = item.quantity;
      quantity.setAttribute('aria-label', item.product_title + ' quantity');
      quantity.dataset.locked = String(legacy || quoteOnly);
      quantity.addEventListener('change', () => run(quantity, () => changeItem(item, Number(quantity.value),{context:'dialog',target:quantity})));
      label.append(quantity);
      const remove = el('button', 'Remove');
      remove.type = 'button';
      remove.setAttribute('aria-label', 'Remove ' + item.product_title);
      remove.addEventListener('click', () => run(remove, () => changeItem(item, 0,{context:'dialog',target:remove})));
      controls.append(label, remove);
      info.append(controls);
      const progress = offerBar(item.variant_id, item.quantity, true);
      if (progress && !legacy) info.append(progress);
      line.append(photo, info);
      cartBody.append(line);
    }
    if (!cart.items.length) cartBody.append(el('p', 'Your order is empty. Browse supplies to get started.', 'empty'));
    cartBody.append(summary(cart));
    if (!adapter.uncertain) {
      const delivery = window.ToscaRefinements?.delivery(cart);
      if (delivery) cartBody.append(delivery);
    }
    if (quoteItems) cartBody.append(el('p', 'Remove custom printed cans before checkout and request a quote separately.', 'note'));
    if (legacyItems) cartBody.append(el('p', 'Remove the saved items marked above and add them again before checkout.', 'note'));
    if (adapter.uncertain) cartBody.append(el('p', 'Update uncertain. Review the cart page before making another change.', 'note'));
    const review = dialog?.querySelector('a.btn');
    if (review) review.textContent = legacyItems || quoteItems || adapter.uncertain ? 'Review order →' : 'Review order & checkout →';
    syncControls();
    drawAddons(cart, version);
    drawCartPage(cart);
  }

  function drawCartPage(cart) {
    if (!cartPageForm?.classList.contains('enhanced')) return;
    const lines = cartPageForm.querySelector('.cart-page-lines');
    if (!lines) return;
    lines.replaceChildren();
    for (const item of window.ToscaOffers.groupedItems(cart)) {
      const article = el('article', undefined, 'cart-page-line');
      const photo = el('a', undefined, 'cart-page-image');photo.href = item.url;
      if (item.image) {const img = el('img');img.src = item.image;img.alt = item.product_title;img.width=150;img.height=150;photo.append(img);}
      const body = el('div', undefined, 'cart-page-product');
      const title=el('h2');const link=el('a', item.product_title);link.href=item.url;title.append(link);body.append(title);
      const blocked = Boolean(item.selling_plan_allocation) || item.handle === 'custom-printed-pet-cans';
      if (blocked) body.append(el('p','Remove this saved item before checkout. Add current supplies from the shop, or request a separate custom-can quote.','note'));
      body.append(el('p', item.quantity + ' packs · ' + money(item.final_line_price) + (includesTax(cart) ? ' incl GST' : ' ex GST') + ' after any discounts', 'cart-page-plan'));
      const progress = offerBar(item.variant_id, item.quantity, true);
      if (progress && !blocked) body.append(progress);
      const label=el('label','Quantity');const input=el('input');input.type='number';input.name='updates[]';input.min=0;input.max=30;input.step=1;input.value=item.quantity;input.inputMode='numeric';input.dataset.key=item.key;input.dataset.locked=String(blocked);input.setAttribute('aria-label','Quantity for '+item.product_title);
      input.addEventListener('change',()=>run(input,()=>changeItem(item,Number(input.value)),null,{openDrawer:false,focusKey:item.key}));label.append(input);body.append(label);
      const remove=el('button','Remove','cart-remove');remove.type='button';remove.setAttribute('aria-label','Remove '+item.product_title);remove.addEventListener('click',()=>run(remove,()=>changeItem(item,0),null,{openDrawer:false}));body.append(remove);
      article.append(photo,body,el('strong',money(item.final_line_price),'cart-page-price'));lines.append(article);
    }
    if (!cart.items.length) lines.append(el('p','Your cart is empty. Choose supplies to start your next order.','cart-page-empty'));
    const totalNode=cartPageForm.querySelector('[data-cart-page-total]');if(totalNode)totalNode.replaceChildren(summary(cart));
    const guide=cartPageForm.querySelector('[data-delivery-guide]');if(guide){guide.replaceChildren();if(!adapter.uncertain){const content=window.ToscaRefinements?.delivery(cart);if(content)guide.append(content);}}
    const checkout=cartPageForm.querySelector('.cart-checkout');
    if(checkout)checkout.dataset.locked=String(!cart.item_count || cart.items.some(i=>i.selling_plan_allocation || i.handle==='custom-printed-pet-cans'));
    const warning=cartPageForm.querySelector('[data-cart-warning]');if(warning){warning.textContent=adapter.uncertain?'Your order may have changed. Reload this page to confirm it before checking out.':cart.items.some(i=>i.selling_plan_allocation || i.handle==='custom-printed-pet-cans')?'Remove the flagged items above to continue.':'';}
    syncControls();
  }

  async function run(button, operation, addon, options = {}) {
    if (operationPending || adapter.busy || adapter.uncertain) return;
    operationPending = true;
    say('Updating your order…');
    if (addon) button.textContent = 'Adding…';
    let completed = false;
    try {
      const pending = operation();
      syncControls();
      await pending;
      completed = true;
      if (adapter.lastMutation?.wrote && addon) window.ToscaRefinements?.publish('tosca_addon_added', {product_handle:addon.handle,quantity:1,price_cents:addon.price,currency:adapter.cart.currency});
      if (adapter.lastMutation?.wrote && button?.closest('.shop-restock')) window.ToscaRefinements?.publish('tosca_restock_added', {currency:adapter.cart.currency});
      draw();
      if (options.openDrawer !== false && dialog && !dialog.open) {
        trigger = button;
        dialog.showModal();
        document.querySelector('#cart-close')?.focus();
      }
      say(addon ? addon.title + ' is in your order.' : 'Order updated.');
    } catch (error) {
      if (addon) catalogueCache = null;
      draw();
      say(error.message);
    } finally {
      operationPending = false;
      syncControls();
      if (options.openDrawer === false && !button?.isConnected) {
        const replacement=[...document.querySelectorAll('.cart-page-form input[data-key]')].find(n=>n.dataset.key===options.focusKey);
        (replacement || cartPageForm?.querySelector('.cart-checkout:not(:disabled)') || cartPageForm?.querySelector('a[href]'))?.focus({preventScroll:true});
      }
      if (dialog?.open && button && !button.isConnected) {
        // Re-rendered controls must not drop keyboard focus outside the modal.
        (addon ? dialog.querySelector('a.btn') : document.querySelector('#cart-close'))?.focus({preventScroll: true});
      }
      if (!completed && adapter.uncertain && dialog && !dialog.open) {
        trigger = button;
        dialog.showModal();
        document.querySelector('#cart-close')?.focus();
      }
    }
  }

  for (const form of forms) {
    form.addEventListener('input', () => update(form));
    form.addEventListener('change', () => update(form));
    form.addEventListener('submit', event => {
      event.preventDefault();
      try {
        const {id, quantity} = state(form);
        const submitter = event.submitter || form.querySelector('[type="submit"]');
        run(submitter, () => adapter.add([{id, quantity}],{context:'product',target:submitter}));
      } catch (error) {
        say(error.message);
      }
    });
    update(form);
  }

  for (const form of document.querySelectorAll('.shop-restock')) {
    const rows=[...form.querySelectorAll('.restock-option')];
    const total=form.querySelector('.restock-total');const button=form.querySelector('[type="submit"]');
    const selection=()=>rows.filter(r=>r.querySelector('[type="checkbox"]').checked).map(row=>{
      const option=row.querySelector('select').selectedOptions[0];const quantity=Number(row.querySelector('[type="number"]').value);
      const id=Number(option.value),max=Math.min(30,Number(option.dataset.max));
      if(!Number.isSafeInteger(id)||id<=0||!Number.isInteger(quantity)||quantity<1||quantity>max||option.disabled)throw new Error('Check the selected quantities and available products.');
      return {id,quantity,price:Number(option.dataset.price)};
    });
    const updateRestock=()=>{try{const selected=selection();total.textContent=selected.length?money(selected.reduce((sum,i)=>{const amount=window.ToscaCartonTotal(i.id,i.price,i.quantity);return sum+amount+(settings.taxesIncluded?0:Math.round(amount/10));},0))+' incl. GST · includes eligible bulk savings':'Choose the supplies you need. Nothing is preselected.';button.dataset.locked=String(!selected.length);button.disabled=!selected.length||operationPending||adapter.busy||adapter.uncertain;}catch(e){total.textContent=e.message;button.dataset.locked='true';button.disabled=true;}};
    form.addEventListener('input',updateRestock);form.addEventListener('change',updateRestock);
    form.addEventListener('submit',event=>{event.preventDefault();try{const items=selection();if(!items.length)return;run(event.submitter||button,()=>adapter.add(items.map(({id,quantity})=>({id,quantity}))));}catch(e){say(e.message);}});
    updateRestock();
  }

  if (cartPageForm) {
    cartPageForm.addEventListener('submit', event => {
      if (operationPending || adapter.busy || adapter.uncertain || event.submitter?.dataset.locked === 'true') {event.preventDefault();say(adapter.uncertain?'Reload this page to confirm your order before checking out.':'Finishing your order update…');}
    });
    operationPending = true;
    syncControls();
    adapter.read().then(()=>{cartPageForm.classList.add('enhanced');draw();}).catch(()=>{say('Use Update order after changing quantities, then continue to checkout.');}).finally(()=>{operationPending=false;syncControls();});
  }

  document.querySelector('#cart-open')?.addEventListener('click', async event => {
    trigger = event.currentTarget;
    if (dialog && !dialog.open) dialog.showModal();
    if (feedback) feedback.textContent = '';
    document.querySelector('#cart-close')?.focus();
    if (operationPending || adapter.busy) return;
    operationPending = true;
    ++drawVersion;
    syncControls();
    try {
      await adapter.read();
      draw();
    } catch {
      cartBody?.replaceChildren(el('p', 'Your order could not be refreshed. Open the cart page to review it.', 'note'));
      say('Could not load your order. Open the cart page to review it.');
    } finally {
      operationPending = false;
      syncControls();
    }
  });
  document.querySelector('#cart-close')?.addEventListener('click', () => dialog?.close());
  dialog?.addEventListener('close', () => {
    ++drawVersion;
    if (trigger?.isConnected) trigger.focus();
  });
  dialog?.querySelector('a.btn')?.addEventListener('click', event => {
    if (operationPending || adapter.busy) { event.preventDefault(); say('Finishing your order update…'); }
  });
  dialog?.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('button,a[href],input,select,[tabindex]')].filter(node => !node.disabled && node.tabIndex >= 0 && node.getClientRects().length);
    const first = focusable[0];
    const last = focusable.at(-1);
    if (!first) return;
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.querySelector('.menu-toggle')?.addEventListener('click', event => {
    const nav = document.querySelector('header nav');
    if (nav) event.currentTarget.setAttribute('aria-expanded', String(nav.classList.toggle('open')));
  });
  function filter() {
    const query = document.querySelector('#shop-search')?.value.toLowerCase() || '';
    const category = document.querySelector('#shop-filter')?.value || 'All';
    let count = 0;
    document.querySelectorAll('[data-search]').forEach(card => {
      card.hidden = !(card.dataset.search.toLowerCase().includes(query) && (category === 'All' || category === card.dataset.category));
      if (!card.hidden) count++;
    });
    const empty = document.querySelector('#shop-empty');
    if (empty) empty.hidden = count > 0;
  }
  document.querySelector('#shop-search')?.addEventListener('input', filter);
  document.querySelector('#shop-filter')?.addEventListener('change', filter);
})();
